module.exports = "/packs/images/our-story/hero-mobile@2x-7bcb063d8080e4f164cb704a83101326.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/our-story/hero-mobile@2x.jpg
// module id = 1789
// module chunks = 0